import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./SuccessHandler.sass";
import help_image from "../images/Illustration-help.png";
import { BASE } from "../basedata/constants";
import MobilePagination from "../components/MobilePagination/MobilePagination";
import { useStep } from "../context/StepContext"

const MessageErrorHandler = () => {
  const { t } = useTranslation(); 
  const { setStep } = useStep();
  const [accepted, setAccepted] = useState(false);



  useEffect(() => {
    setStep(6);
    const _temp_language = sessionStorage.getItem('language') || 'pt'
    sessionStorage.clear()
    sessionStorage.setItem('success_flow', 'true')
    sessionStorage.setItem('language', _temp_language)
  }, []);


  return (
    <div className="success-container">
      <div className="left-side"></div> 
      <div className="right-side">
        <div className="success-card">
          <img className="logo" src={BASE.company.logo} alt={BASE.company.name} />
          <h1 className="success_title">
            {t("support_message.title")}
          </h1>
          <div className="success-message-container">
            <p className="success-message">
            {t("support_message.support_quote")}
            </p>
            <p className="success-message">
            {t("support_message.support_contact_label")}<br/><br/>
            {BASE.company.contact_data.map((item) => (
            <>
              <strong>{item.type}:</strong> {item.value} <br/>
              {/* <a className="contact-link" href="https://atendimento.spfcticket.net/hc/pt-br/requests/new">Entre em contato clicando aqui</a> */}

            </>
            ))}
            </p>
            {/* <img src={help_image} alt="Sucesso!" className="no-svg-tip" /> */}
            <p className="success-message">
            <br/>
              {t("support_message.support_contact_text")}
            <br/>
            </p>
          </div>
        </div>
      </div>
      {/* <footer className="success-footer">
        <div className="success-footer-logo"></div>
      </footer> */}
    </div>
  );
};

export default MessageErrorHandler;